import React, { useState, useEffect } from 'react';
import { Table, Card, Row, Col, Form, Button, Spinner, Badge, Collapse } from 'react-bootstrap';
import axios from 'axios';
import { FaDownload, FaFilePdf, FaBuilding, FaCalendarAlt, FaMoneyBillWave, FaChevronDown, FaChevronUp, FaDollarSign, FaCreditCard, FaPiggyBank, FaBalanceScale, FaReceipt, FaFileInvoiceDollar } from 'react-icons/fa';
import "react-datepicker/dist/react-datepicker.css";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
const PartnerSOA = () => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [partners, setPartners] = useState([]);
    const [selectedPartner, setSelectedPartner] = useState('');
    const [selectedPartnerName, setSelectedPartnerName] = useState('');
    const [selectedPartnerCurrency, setSelectedPartnerCurrency] = useState('AED');
    const [partnerProjects, setPartnerProjects] = useState([]);
    const [loading, setLoading] = useState(false);
    const [generatingPDF, setGeneratingPDF] = useState(false);
    const [openProjects, setOpenProjects] = useState({});
    const [partnerPaymentSchedule, setPartnerPaymentSchedule] = useState([]);


    // Fetch partners on mount
    useEffect(() => {
        fetchPartners();
    }, []);
      const getDayjsDate = (dateString) => {
        return dateString ? dayjs(dateString) : null;
      };

    const fetchPartners = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/organisation?org_type=partner`, {
                headers: { Authorization: `Bearer ${token}`, 'Tenant-Origin': origin }
            });
            setPartners(response.data.data || []);
        } catch (error) {
            console.error('Error fetching partners:', error);
        }
    };

    const fetchPartnerProjects = async () => {
        if (!selectedPartner) return alert("Please select a partner");
        setLoading(true);

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem("user-origin");
            const token = userInfo?.token;

            const selectedPartnerObj = partners.find(p => p.id === Number(selectedPartner));
            setSelectedPartnerName(selectedPartnerObj?.name || '');
            setSelectedPartnerCurrency(selectedPartnerObj?.currency || 'AED');

            const response = await axios.get(`${backendUrl}/api/partner-soa?partner_id=${selectedPartner}&start_date=${startDate}&end_date=${endDate}`, {
                headers: { Authorization: `Bearer ${token}`, 'Tenant-Origin': origin }
            });

            const { projects, project_names, deals, invoices, transactions, paymentSchedule } = response.data;
setPartnerPaymentSchedule(paymentSchedule); 
            // Group data by project
            const projectsWithData = projects.map(projectId => {
                const projDeals = deals.filter(d => d.project_id === projectId);
                const projInvoices = invoices.filter(inv => inv.project_id === projectId);
                const projTransactions = transactions.filter(tx => tx.project_id === projectId);

                const processedData = processSOAData(
                    projDeals,
                    projInvoices,
                    projTransactions,
                    selectedPartnerObj?.currency || 'AED',
                    0.05
                );

                return {
                    id: projectId,
                    name: project_names[projectId] || `Project ${projectId}`,
                    projectCode: `PROJ-${projectId}`,
                    transactions: processedData.transactions,
                    summary: processedData.summary,
                    currency: selectedPartnerObj?.currency || 'AED'
                };
            });

            // Filter out projects with no transactions
            const filteredProjects = projectsWithData.filter(
                proj => proj.transactions && proj.transactions.length > 0
            );

            setPartnerProjects(filteredProjects);

            // Initialize all projects as collapsed
            const initialOpenState = {};
            filteredProjects.forEach(proj => {
                initialOpenState[proj.id] = false;
            });
            setOpenProjects(initialOpenState);

        } catch (error) {
            console.error(error);
            alert('Error fetching partner projects. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const processSOAData = (deals, invoices, transactions, currency, vatRate) => {
        const isAED = currency === 'AED';
        const groupedData = [];
        let runningBalance = 0;
        let totalDebit = 0;
        let totalCredit = 0;
        let totalVAT = 0;
        let totalAdvance = 0;
        let carryForwardAdvance = 0;

        const quotationToDealMap = {};
        deals.forEach(deal => {
            if (deal.quotation_id) quotationToDealMap[deal.quotation_id] = deal.id;
        });

        const invoicesByDeal = {};
        invoices.forEach(inv => {
            const dealId = quotationToDealMap[inv.quotation_id] || inv.deal_id;
            if (!dealId) return;
            if (!invoicesByDeal[dealId]) invoicesByDeal[dealId] = [];
            invoicesByDeal[dealId].push(inv);
        });

        const paymentsByInvoice = {};
        transactions.forEach(tx => {
            const invoiceId = tx.invoice_id || tx.reference_invoice_id;
            if (!invoiceId) return;
            if (!paymentsByInvoice[invoiceId]) paymentsByInvoice[invoiceId] = [];
            paymentsByInvoice[invoiceId].push(tx);
        });

        const orderedDeals = [...deals].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

        orderedDeals.forEach(deal => {
            const relatedInvoices = invoicesByDeal[deal.id] || [];
            const hasPayments = relatedInvoices.some(inv => (paymentsByInvoice[inv.id] || []).length > 0);
            if (relatedInvoices.length === 0 && !hasPayments) return;

            // Add order entry
            groupedData.push({
                date: deal.issue_date,
                type: 'Sales Declaration',
                reference: deal.po_number,
                description: `Order: ${deal.name}`,
                debit: 0,
                credit: 0,
                advance: 0,
                runningBalance,
                meta: { kind: 'order' }
            });

            // Process invoices for this deal
            relatedInvoices.forEach(inv => {
                const amount = Number(inv.basic_amount) || 0;
                const vat = isAED ? Number(inv.vat) || 0 : 0;
                const total = Number(inv.total_with_vat) || (amount + vat);
                totalDebit += total;
                totalVAT += vat;

                let appliedAdvance = 0;
                if (carryForwardAdvance > 0) {
                    appliedAdvance = Math.min(carryForwardAdvance, total);
                    carryForwardAdvance -= appliedAdvance;
                }
                runningBalance += (total - appliedAdvance);
                totalCredit += appliedAdvance;

                groupedData.push({
                    date: inv.created_at,
                    type: 'Invoice Raised',
                    reference: inv.ref_no || `INV-${inv.id}`,
                    description: `Invoice: ${inv.ref_no}`,
                    debit: total,
                    credit: appliedAdvance,
                    advance: 0,
                    runningBalance,
                    meta: { kind: 'invoice', invoiceId: inv.id }
                });

                // Process payments for this invoice
                const relatedPayments = paymentsByInvoice[inv.id] || [];
                relatedPayments.forEach(tx => {
                    const received = Number(tx.received_amount) || Math.abs(Number(tx.amount)) || 0;
                    const appliedToInvoice = Math.min(received, runningBalance + appliedAdvance);
                    const overpaid = received - appliedToInvoice;
                    totalCredit += appliedToInvoice;
                    runningBalance -= appliedToInvoice;
                    if (overpaid > 0) {
                        carryForwardAdvance += overpaid;
                        totalAdvance += overpaid;
                    }

                    groupedData.push({
                        date: tx.date,
                        type: 'Payment Received',
                        reference: tx.reference_no || `TRX-${tx.id}`,
                        description: `Payment for ${inv.ref_no}`,
                        debit: 0,
                        credit: appliedToInvoice,
                        advance: overpaid > 0 ? overpaid : 0,
                        runningBalance,
                        meta: { kind: 'payment' }
                    });
                });
            });
        });

        // Add advance carry forward if any
        if (carryForwardAdvance > 0) {
            groupedData.push({
                date: new Date().toISOString().split('T')[0],
                type: 'Advance Balance',
                reference: 'ADV-CF',
                description: `Advance balance carried forward`,
                debit: 0,
                credit: 0,
                advance: carryForwardAdvance,
                runningBalance,
                meta: { kind: 'advance' }
            });
        }

        return {
            transactions: groupedData,
            summary: {
                openingBalance: 0,
                totalDebit,
                totalCredit,
                totalVAT,
                totalAdvance: carryForwardAdvance,
                closingBalance: runningBalance,
                currency
            }
        };
    };

    const downloadPDF = async () => {
        if (!selectedPartner || partnerProjects.length === 0) {
            alert('Please generate SOA first');
            return;
        }

        setGeneratingPDF(true);
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const pdfData = {
                partnerId: selectedPartner,
                partnerName: selectedPartnerName,
                partnerCurrency: selectedPartnerCurrency,
                startDate,
                endDate,
                projects: partnerProjects.map(proj => {
                    const matchedSchedule = partnerPaymentSchedule?.find(s => s.project_id === proj.id);

                    return {
                        id: proj.id,
                        name: proj.name,
                        code: proj.projectCode,
                        transactions: proj.transactions,
                        summary: proj.summary,
                        currency: proj.currency,
                        paymentSchedule: matchedSchedule ? matchedSchedule.paymentSchedule : []
                    };
                })
            };


                const response = await axios.post(
                    `${backendUrl}/api/soa/generate-pdf`,
                    pdfData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Tenant-Origin': origin,
                            'Content-Type': 'application/json'
                        },
                        responseType: 'blob'
                    }
                );

                // Create blob and trigger download
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `SOA_${selectedPartnerName.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

            } catch (error) {
                console.error('Error generating PDF:', error);
                alert('Error generating PDF. Please try again.');
            } finally {
                setGeneratingPDF(false);
            }
        };

        const formatNumber = (amount) => {
            if (isNaN(amount) || amount == null) amount = 0;
            return new Intl.NumberFormat('en-AE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(amount);
        };

        const formatCurrency = (amount) => {
            return `${formatNumber(amount)} ${selectedPartnerCurrency}`;
        };

        const formatDate = (dateString) => {
            if (!dateString) return '-';
            try {
                return new Date(dateString).toLocaleDateString('en-GB');
            } catch {
                return '-';
            }
        };

        const toggleProject = (projectId) => {
            setOpenProjects(prev => ({
                ...prev,
                [projectId]: !prev[projectId]
            }));
        };

        const toggleAllProjects = (expand) => {
            const newState = {};
            partnerProjects.forEach(proj => {
                newState[proj.id] = expand;
            });
            setOpenProjects(newState);
        };

        const calculateOverallSummary = () => {
            return partnerProjects.reduce((acc, project) => {
                acc.totalDebit += project.summary.totalDebit;
                acc.totalCredit += project.summary.totalCredit;
                acc.totalAdvance += project.summary.totalAdvance;
                acc.closingBalance += project.summary.closingBalance;
                return acc;
            }, {
                totalDebit: 0,
                totalCredit: 0,
                totalAdvance: 0,
                closingBalance: 0
            });
        };

        const overallSummary = calculateOverallSummary();

        return (
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        {/* Header */}
                        <div className="row mb-4">
                            <div className="col-12">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                        <h4 className="mb-1 fw-bold text-dark">Statement of Accounts</h4>
                                        <p className="text-muted mb-0">Partner financial statements and transaction details</p>
                                    </div>

                                </div>
                            </div>
                        </div>

                        {/* Filters Card */}
                        <Card className="mb-4">
                            <Card.Header className="bg-transparent border-bottom d-flex justify-content-between align-items-center">
                                <h5 className="card-title mb-0 d-flex align-items-center">
                                    <FaBuilding className="me-2 text-primary" />
                                    Partner Statement Filters
                                </h5>

                                <Button
                                    variant="outline-dark"
                                    onClick={downloadPDF}
                                    disabled={generatingPDF}
                                    className="d-flex align-items-center"
                                >
                                    {generatingPDF ? (
                                        <Spinner animation="border" size="sm" />
                                    ) : (
                                        <>
                                            <FaFilePdf className="me-2" />
                                            Export PDF
                                        </>
                                    )}
                                </Button>
                            </Card.Header>

                            <Card.Body>
                                <Row className="g-3">
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label className="fw-semibold">Select Partner</Form.Label>
                                            <Form.Select
                                                value={selectedPartner}
                                                onChange={e => setSelectedPartner(e.target.value)}
                                                className="border-2"
                                            >
                                                <option value="">Choose Partner...</option>
                                                {partners.map(p => (
                                                    <option key={p.id} value={p.id}>
                                                        {p.name} {p.currency ? `(${p.currency})` : ''}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label className="fw-semibold d-flex align-items-center">
                                                <FaCalendarAlt className="me-2 text-muted" />
                                                From Date
                                            </Form.Label>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          views={["year", "month", "day"]}
                          format="DD-MM-YYYY"
                          value={getDayjsDate(startDate)}
                          onChange={(newValue) => {
                            setStartDate(newValue ? newValue.format('YYYY-MM-DD') : '');
                          }}
                          slotProps={{
                            textField: { size: "small", fullWidth: true },
                            popper: { sx: { "& .MuiPaper-root": { fontSize: "0.7rem", minWidth: 260 } } },
                          }}
                        />
                      </LocalizationProvider>
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label className="fw-semibold d-flex align-items-center">
                                                <FaCalendarAlt className="me-2 text-muted" />
                                                To Date
                                            </Form.Label>
                                          <LocalizationProvider dateAdapter={AdapterDayjs}>

                                            <DatePicker
                                                views={["year", "month", "day"]}
                                                format="DD-MM-YYYY"
                                                value={getDayjsDate(endDate)}
                                                onChange={(newValue) => {
                                                    setEndDate(newValue ? newValue.format('YYYY-MM-DD') : '');
                                                }}
                                                slotProps={{
                                                    textField: { size: "small", fullWidth: true },
                                                    popper: { sx: { "& .MuiPaper-root": { fontSize: "0.7rem", minWidth: 260 } } },
                                                }}
                                            />
                                        </LocalizationProvider>
                                        </Form.Group>
                                    </Col>

                                    <Col md={2} className="d-flex align-items-end">
                                        <Button
                                            variant="primary"
                                            onClick={fetchPartnerProjects}
                                            disabled={loading || !selectedPartner}
                                            className="w-100 py-2"
                                        >
                                            {loading ? (
                                                <>
                                                    <Spinner animation="border" size="sm" className="me-2" />
                                                    Generating...
                                                </>
                                            ) : (
                                                'Generate SOA'
                                            )}
                                        </Button>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>


                        {/* Results Section */}
                        {partnerProjects.length > 0 && (
                            <>
                                {/* Overall Summary Dashboard */}
                                <Card className="mb-4 border-0 shadow-sm">
                                    <Card.Header className="bg-white border-bottom py-3">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h6 className="mb-0 text-dark fw-bold d-flex align-items-center">
                                                <FaReceipt className="me-2 text-primary" />
                                                Financial Summary
                                            </h6>
                                            {/* <div className="d-flex gap-2">
                                            <Button
                                                variant="outline-primary"
                                                size="sm"
                                                onClick={() => toggleAllProjects(true)}
                                                className="fw-semibold"
                                            >
                                                Expand All
                                            </Button>
                                            <Button
                                                variant="outline-secondary"
                                                size="sm"
                                                onClick={() => toggleAllProjects(false)}
                                                className="fw-semibold"
                                            >
                                                Collapse All
                                            </Button>
                                        </div> */}
                                        </div>
                                    </Card.Header>
                                    <Card.Body className="p-4">
                                        <Row className="g-4 text-center">
                                            <Col md={3}>
                                                <div className="p-3 border rounded bg-light h-100">
                                                    <div className="d-flex align-items-center justify-content-center mb-2">
                                                        <FaFileInvoiceDollar className="text-success fs-4 me-2" />
                                                        <h6 className="text-muted mb-0">Total Debit</h6>
                                                    </div>
                                                    <h4 className="text-success fw-bold mb-0">{formatCurrency(overallSummary.totalDebit)}</h4>
                                                    <small className="text-muted">Invoices & Orders</small>
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div className="p-3 border rounded bg-light h-100">
                                                    <div className="d-flex align-items-center justify-content-center mb-2">
                                                        <FaCreditCard className="text-info fs-4 me-2" />
                                                        <h6 className="text-muted mb-0">Total Credit</h6>
                                                    </div>
                                                    <h4 className="text-info fw-bold mb-0">{formatCurrency(overallSummary.totalCredit)}</h4>
                                                    <small className="text-muted">Payments Received</small>
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div className="p-3 border rounded bg-light h-100">
                                                    <div className="d-flex align-items-center justify-content-center mb-2">
                                                        <FaPiggyBank className="text-warning fs-4 me-2" />
                                                        <h6 className="text-muted mb-0">Total Advance</h6>
                                                    </div>
                                                    <h4 className="text-warning fw-bold mb-0">{formatCurrency(overallSummary.totalAdvance)}</h4>
                                                    <small className="text-muted">Advance Balance</small>
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div className="p-3 border rounded bg-light h-100">
                                                    <div className="d-flex align-items-center justify-content-center mb-2">
                                                        <FaBalanceScale className="text-primary fs-4 me-2" />
                                                        <h6 className="text-muted mb-0">Net Balance</h6>
                                                    </div>
                                                    <h4 className={`fw-bold mb-0 ${overallSummary.closingBalance >= 0 ? 'text-primary' : 'text-danger'}`}>
                                                        {formatCurrency(overallSummary.closingBalance)}
                                                    </h4>
                                                    <small className="text-muted">Current Outstanding</small>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>

                                {/* Projects List */}
                                <Card className="border-0 shadow-sm">
                                    <Card.Header className="bg-white border-bottom py-3">
                                        <h6 className="mb-0 text-dark fw-bold d-flex align-items-center">
                                            <FaBuilding className="me-2 text-primary" />
                                            Project Details ({partnerProjects.length} Projects)
                                        </h6>
                                    </Card.Header>
                                    <Card.Body className="p-0">
                                        {partnerProjects.map((proj, index) => (
                                            <div key={proj.id} className={`border-bottom ${index % 2 === 0 ? 'bg-white' : 'bg-light'}`}>
                                                {/* Project Header - Clickable */}
                                                <div
                                                    className="p-4 cursor-pointer project-header"
                                                    onClick={() => toggleProject(proj.id)}
                                                    style={{
                                                        cursor: 'pointer',
                                                        transition: 'all 0.3s ease',
                                                        borderLeft: openProjects[proj.id] ? '4px solid #007bff' : '4px solid transparent'
                                                    }}
                                                >
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className="d-flex align-items-center flex-grow-1">
                                                            <div className="me-3">
                                                                {openProjects[proj.id] ? (
                                                                    <FaChevronUp className="text-primary" />
                                                                ) : (
                                                                    <FaChevronDown className="text-primary" />
                                                                )}
                                                            </div>
                                                            <div className="flex-grow-1">
                                                                <div className="d-flex align-items-center mb-1">
                                                                    <h6 className="mb-0 fw-bold text-dark me-3">{proj.name}</h6>
                                                                    <Badge bg="outline-primary" className="text-dark border">
                                                                        {proj.projectCode}
                                                                    </Badge>
                                                                </div>
                                                                <div className="d-flex align-items-center gap-3">
                                                                    <small className="text-muted d-flex align-items-center">
                                                                        <FaReceipt className="me-1" size={12} />
                                                                        {proj.transactions.length} transactions
                                                                    </small>
                                                                    <small className="text-muted d-flex align-items-center">
                                                                        <FaDollarSign className="me-1" size={12} />
                                                                        Currency: {proj.currency}
                                                                    </small>
                                                                    <small className={`d-flex align-items-center fw-semibold ${proj.summary.closingBalance >= 0 ? 'text-success' : 'text-danger'
                                                                        }`}>
                                                                        Balance: {formatCurrency(proj.summary.closingBalance)}
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="text-end">
                                                            <div className="d-flex gap-4">
                                                                <div className="text-center">
                                                                    <small className="text-muted d-block">Debit</small>
                                                                    <span className="text-success fw-bold">{formatCurrency(proj.summary.totalDebit)}</span>
                                                                </div>
                                                                <div className="text-center">
                                                                    <small className="text-muted d-block">Credit</small>
                                                                    <span className="text-info fw-bold">{formatCurrency(proj.summary.totalCredit)}</span>
                                                                </div>
                                                                <div className="text-center">
                                                                    <small className="text-muted d-block">Advance</small>
                                                                    <span className="text-warning fw-bold">{formatCurrency(proj.summary.totalAdvance)}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Collapsible Transaction Table */}
                                                <Collapse in={openProjects[proj.id]}>
                                                    <div>
                                                        <div className="p-4 bg-white border-top">
                                                            {/* Project Summary */}
                                                            <div className="row mb-4">
                                                                <div className="col-12">
                                                                    <div className="bg-light p-3 rounded">
                                                                        <h6 className="fw-bold mb-3 text-dark">Project Summary</h6>
                                                                        <Row className="text-center">
                                                                            <Col md={3}>
                                                                                <div className="border-end">
                                                                                    <small className="text-muted d-block">Opening Balance</small>
                                                                                    <span className="fw-bold text-dark">{formatCurrency(proj.summary.openingBalance)}</span>
                                                                                </div>
                                                                            </Col>
                                                                            <Col md={3}>
                                                                                <div className="border-end">
                                                                                    <small className="text-muted d-block">Total Debit</small>
                                                                                    <span className="fw-bold text-success">{formatCurrency(proj.summary.totalDebit)}</span>
                                                                                </div>
                                                                            </Col>
                                                                            <Col md={3}>
                                                                                <div className="border-end">
                                                                                    <small className="text-muted d-block">Total Credit</small>
                                                                                    <span className="fw-bold text-info">{formatCurrency(proj.summary.totalCredit)}</span>
                                                                                </div>
                                                                            </Col>
                                                                            <Col md={3}>
                                                                                <div>
                                                                                    <small className="text-muted d-block">Closing Balance</small>
                                                                                    <span className={`fw-bold ${proj.summary.closingBalance >= 0 ? 'text-primary' : 'text-danger'
                                                                                        }`}>
                                                                                        {formatCurrency(proj.summary.closingBalance)}
                                                                                    </span>
                                                                                </div>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Transactions Table */}
                                                            <div className="table-responsive">
                                                              <table className="table align-middle table-nowrap table-check table-list">

                                                <thead className="table-light">
                                                    <tr>
                                                                  <th style={{ width: '8%' }}>Date</th>
                                                        <th style={{ width: '10%' }}>Type</th>
                                                        <th style={{ width: '10%' }}>Ref No</th>
                                                        <th>Description</th>
                                                        <th className="text-end" style={{ width: '10%' }}>Debit </th>
                                                        <th className="text-end" style={{ width: '10%' }}>Credit </th>
                                                        <th className="text-end" style={{ width: '10%' }}>Balance </th>
                                                    </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {proj.transactions.length > 0 ? (
                                                                            proj.transactions.map((t, i) => (
                                                                                <tr key={i} className="border-bottom">
                                                                                    <td className="ps-4">
                                                                                        <small className="text-muted fw-semibold">{formatDate(t.date)}</small>
                                                                                    </td>
                                                                                    <td>
                                                                                        <Badge
                                                                                            bg={
                                                                                                t.type === 'Sales Declaration' ? 'light' :
                                                                                                    t.type === 'Invoice Raised' ? 'light' :
                                                                                                        t.type === 'Payment Received' ? 'light' :
                                                                                                            'light'
                                                                                            }
                                                                                            className="fs-12 fw-normal"
                                                                                        >
                                                                                            {t.type}
                                                                                        </Badge>
                                                                                    </td>
                                                                                    <td>
                                                                                        <code className="text-dark fs-12 bg-light px-2 py-1 rounded">
                                                                                            {t.reference}
                                                                                        </code>
                                                                                    </td>
                                                                                    <td>
                                                                                        <small className="text-start">{t.description}</small>
                                                                                    </td>
                                                                                    <td className="text-end">
                                                                                        {t.debit > 0 ? (
                                                                                            <span className="text-success fw-bold">
                                                                                                {formatNumber(t.debit)}
                                                                                            </span>
                                                                                        ) : '-'}
                                                                                    </td>
                                                                                    <td className="text-end">
                                                                                        {t.credit > 0 ? (
                                                                                            <span className="text-info fw-bold">
                                                                                                {formatNumber(t.credit)}
                                                                                            </span>
                                                                                        ) : '-'}
                                                                                    </td>
                                                                                    <td className="text-end pe-4">
                                                                                        <span className={`fw-bold ${t.runningBalance >= 0 ? 'text-dark' : 'text-danger'
                                                                                            }`}>
                                                                                            {formatNumber(t.runningBalance)}
                                                                                        </span>
                                                                                    </td>
                                                                                </tr>
                                                                            ))
                                                                        ) : (
                                                                            <tr>
                                                                                <td colSpan="7" className="text-center py-4">
                                                                                    <div className="text-muted">
                                                                                        <FaMoneyBillWave size={32} className="mb-2 opacity-50" />
                                                                                        <p className="mb-0">No transactions found for this project</p>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        )}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Collapse>
                                            </div>
                                        ))}
                                    </Card.Body>
                                </Card>
                            </>
                        )}
                    </div>
                </div>

                <style jsx>{`
                .project-header:hover {
                    background-color: #f8f9fa !important;
                }
                .table-light th {
                    font-weight: 600;
                    font-size: 0.875rem;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }
                .border-0 {
                    border: none !important;
                }
                .fs-12 {
                    font-size: 0.75rem;
                }
                .cursor-pointer {
                    cursor: pointer;
                }
            `}</style>
            </div>
        );
    };

    export default PartnerSOA;